/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface LaxRecommendationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param file 
     */
    laxRecommendationEmailControllerSendLaxRecommendationByStrategy0(file: Blob, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param file 
     */
    laxRecommendationEmailControllerSendLaxRecommendationByStrategy1(file: Blob, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param inviterUsername 
     * @param file 
     */
    laxRecommendationEmailControllerSendTraditionalInvite0(inviterUsername: string, file: Blob, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param inviterUsername 
     * @param file 
     */
    laxRecommendationEmailControllerSendTraditionalInvite1(inviterUsername: string, file: Blob, extraHttpRequestParams?: any): Observable<{}>;

}
